var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrokenVehicle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 123.333 63.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "inherit",
    "data-name": "Group 2088",
    transform: "translate(-1496.499 -609.424)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2087"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1591.598 673.131h-.29a11.2 11.2 0 0 1-7.819-3.475 11.02 11.02 0 0 1-3.041-7.963 11.2 11.2 0 0 1 3.475-7.819 11.161 11.161 0 0 1 18.823 8.108v.29a11.094 11.094 0 0 1-11.148 10.859m0-18.1a6.92 6.92 0 0 0-6.95 6.66 6.77 6.77 0 0 0 1.882 4.923 7.34 7.34 0 0 0 4.778 2.172 6.924 6.924 0 0 0 7.095-6.66v-.145a6.675 6.675 0 0 0-6.66-6.805c-.001-.143-.001-.143-.145-.143z",
    "data-name": "Path 3267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1591.743 667.34a5.8 5.8 0 0 1-3.764-1.448 5.47 5.47 0 0 1-1.738-3.909 5.41 5.41 0 0 1 5.357-5.647h.145a5.38 5.38 0 0 1 5.5 5.357v.145a5.59 5.59 0 0 1-5.5 5.5zm0-6.66a1.14 1.14 0 0 0-1.158 1.158 1.25 1.25 0 0 0 .434.869 1.06 1.06 0 0 0 .869.29 1.246 1.246 0 0 0 1.158-1.158 1.37 1.37 0 0 0-1.303-1.159",
    "data-name": "Path 3268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1612.158 659.231h-11a1.94 1.94 0 0 1-1.882-1.158 7.34 7.34 0 0 0-3.62-3.62l-.145-.145a8.03 8.03 0 0 0-10.859 3.764 2.26 2.26 0 0 1-1.882 1.158h-29.827a1.94 1.94 0 0 1-1.882-1.158 7.97 7.97 0 0 0-3.62-3.62h-.145a8.236 8.236 0 0 0-11 3.765 2.26 2.26 0 0 1-1.882 1.158h-7.674a2.227 2.227 0 0 1-2.172-2.172v-32.142a6.9 6.9 0 0 1 2.027-4.923 6.8 6.8 0 0 1 4.778-2.027h48.649a5.39 5.39 0 0 1 5.212 4.054l3.62 13.321 20.85 1.3a5.47 5.47 0 0 1 5.212 5.647l-.145 14.769a3.15 3.15 0 0 1-2.613 2.029m-9.846-4.344h7.529l.145-12.6v-.145a1.37 1.37 0 0 0-1.158-1.3l-22.3-1.448a2.32 2.32 0 0 1-2.027-1.593l-4.054-14.769a1.09 1.09 0 0 0-1.014-.724h-48.649a2.47 2.47 0 0 0-2.461 2.461v29.971h4.344a12.393 12.393 0 0 1 16.072-4.488l.29.145a12.6 12.6 0 0 1 4.778 4.344h27.365a12.393 12.393 0 0 1 16.072-4.488l.29.145a11.9 11.9 0 0 1 4.778 4.489m-34.46-7.963h-6.081a2.172 2.172 0 1 1 0-4.344h6.081a2.172 2.172 0 1 1 0 4.344",
    "data-name": "Path 3269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1535.42 620.284a2.227 2.227 0 0 1-2.172-2.172v-5.5a2.172 2.172 0 1 1 4.344 0v5.5a2.227 2.227 0 0 1-2.172 2.172",
    "data-name": "Path 3270"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.486 620.284a2.227 2.227 0 0 1-2.172-2.172v-5.5a2.172 2.172 0 0 1 4.344 0v5.5a2.13 2.13 0 0 1-2.172 2.172",
    "data-name": "Path 3271"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1579.725 613.768h-51.69a2.172 2.172 0 1 1 0-4.344h51.69a2.227 2.227 0 0 1 2.172 2.172 2.13 2.13 0 0 1-2.172 2.172",
    "data-name": "Path 3272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.813 661.549h-9.99a2.172 2.172 0 1 1 0-4.344h9.99a2.227 2.227 0 0 1 2.172 2.172 2.13 2.13 0 0 1-2.172 2.172",
    "data-name": "Path 3273"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1581.753 661.549h-27.655a2.172 2.172 0 1 1 0-4.344h27.655a2.172 2.172 0 1 1 0 4.344",
    "data-name": "Path 3274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.66 661.548h-17.085a2.172 2.172 0 0 1 0-4.344h14.913v-10.565a2.172 2.172 0 0 1 4.344 0v12.741a2.227 2.227 0 0 1-2.172 2.168",
    "data-name": "Path 3275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1586.82 639.541h-59.219a2.172 2.172 0 1 1 0-4.344h59.219a2.172 2.172 0 1 1 0 4.344",
    "data-name": "Path 3276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.849 639.106a2.227 2.227 0 0 1-2.172-2.172v-16.647a2.172 2.172 0 1 1 4.344 0v16.651a2.13 2.13 0 0 1-2.172 2.168",
    "data-name": "Path 3277"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1526.153 651.123h-4.633a5.654 5.654 0 0 1-5.647-5.647v-13.175a5.654 5.654 0 0 1 5.647-5.647h4.633a2.227 2.227 0 0 1 2.172 2.172v20.126a2.052 2.052 0 0 1-2.172 2.171m-4.633-19.981a1.3 1.3 0 0 0-1.3 1.3v13.176a1.3 1.3 0 0 0 1.3 1.3h2.461v-15.775z",
    "data-name": "Path 3278"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 22.556,
    height: 7.089,
    "data-name": "Rectangle 1693",
    rx: 1.708,
    transform: "translate(1496.499 666.043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531.277 658.4h2.617v13.283h-2.617z",
    "data-name": "Rectangle 1694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1535.903 673.132h-6.635l1.581-2.75h3.473z",
    "data-name": "Path 3279"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.684,
    height: 1.407,
    "data-name": "Rectangle 1695",
    rx: 0.486,
    transform: "rotate(16.19 -1574.228 5686.48)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.4,
    cy: 3.4,
    r: 3.4,
    "data-name": "Ellipse 81",
    transform: "translate(1540.01 657.638)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1543.413 662.116c-5.8 0-10.339-2.391-10.339-5.441l1.448-.724c0 1.888 3.652 3.993 8.891 3.993s8.893-2.105 8.893-3.993l1.448.724c-.004 3.051-4.541 5.441-10.341 5.441",
    "data-name": "Path 3280"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenVehicle);
export default __webpack_public_path__ + "static/media/brokenVehicle.13e9f5c1dbd4310d2f5ac809f6e87f89.svg";
export { ForwardRef as ReactComponent };